module.exports = __webpack_public_path__ + "media/img/files/file-3-25d168d07d998a0c4ec8723eeaf6d64f.jpg";